// Níveis de permissão do sistema
export const PERMISSION_LEVELS = {
	MASTER: 1,
	MANAGER: 2,
	USER: 3
}

// Mapeamento para facilitar comparações
export const PERMISSION_NAMES = {
	1: 'Master',
	2: 'Manager',
	3: 'User'
}

// Helper para verificar se o usuário tem permissão suficiente
export function hasPermission(userPermissionId, requiredPermissionId) {
	// Quanto menor o ID, maior o nível de permissão
	// Master (1) > Manager (2) > User (3)
	return userPermissionId <= requiredPermissionId
}
